export default function initContactBanner() {
  const banners = document.querySelectorAll('.contact-banner');

  if (!banners.length) return;

  banners.forEach((banner) => {
    initImageUpload(banner);
  });

  function initImageUpload(banner) {
    const uploadWrapper = banner.querySelector(
      '[data-name="your-inspiration"]'
    );

    if (!uploadWrapper) return;

    const input = uploadWrapper.querySelector('input[type="file"]');

    if (!input) return;

    const preview = banner.querySelector(
      '.contact-banner__form-file-preview'
    );

    if (!preview) return;

    input.addEventListener('change', () => {
      updatePreview(input, preview);
    });

    initFormReset(banner, input, preview);
  }

  function updatePreview(input, preview) {
    preview.innerHTML = '';

    const files = Array.from(input.files);

    if (!files.length) return;

    const images = files.filter((file) => file.type.startsWith('image/'));

    if (!images.length) return;

    const count = document.createElement('small');

    count.className = 'contact-banner__form-file-preview-count';
    count.textContent = `${images.length} image${
      images.length === 1 ? '' : 's'
    } selected`;

    preview.appendChild(count);

    const grid = document.createElement('div');

    grid.className = 'contact-banner__form-file-preview-grid';

    images.forEach((file) => {
      const item = document.createElement('div');

      item.className = 'contact-banner__form-file-preview-item';

      const image = document.createElement('img');

      image.src = URL.createObjectURL(file);
      image.alt = file.name;

      item.appendChild(image);
      grid.appendChild(item);
    });

    preview.appendChild(grid);
  }

  function initFormReset(banner, input, preview) {
    const form = banner.querySelector('.wpcf7-form');

    if (!form) return;

    form.addEventListener('wpcf7reset', () => {
      input.value = '';
      preview.innerHTML = '';
    });
  }
}
